import React from 'react';
import logo_white_original_240 from '../assets/images/logo_white_original_240.png';
import Medsim224 from '../assets/images/Medsim224.jpg';
const Footer = () => {
    return (
        <footer id="footer" className="footer">
            <div className="container-fluid p-0">
                <div className="row g-0">
                    <div className="col-12 col-lg-6 p-4 p-lg-5">
                        <div className="col-12 px-0 px-lg-4"><img src={logo_white_original_240} className="img img-fluid" alt="Saúde Móvel Brasil" /></div>
                        <div className="col-12 subtitle-footer pt-4 px-0 px-lg-4">A Saúde Móvel Brasil tem se destacado na prestação de serviços de saúde em diversas especialidades, facilitando o atendimento, reduzindo filas e melhorando a coleta de dados para rastreamento de doenças. Com resultados positivos, estamos expandido nossas unidades móveis para alcançar mais pessoas e promover a saúde em maior escala.</div>
                        <div className="col-12">
                            <div className="social-buttons">
                                <a href="#" className="social-button"><i className="fab fa-facebook-f"></i></a>
                                <a href="#" className="social-button"><i className="fab fa-twitter"></i></a>
                                <a href="#" className="social-button"><i className="fab fa-linkedin-in"></i></a>
                                <a href="#" className="social-button"><i className="fab fa-youtube"></i></a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <img src={Medsim224} className="img img-fluid" alt="Saúde Móvel Brasil" />
                    </div>
                </div>
            </div>

            <a href="https://wa.me/556598106742" target="_blank" className="whatsapp-button" title="Fale conosco no WhatsApp">
                <i className="fab fa-whatsapp" ></i>
            </a>
        </footer>

    );
};

export default Footer;